import styled from '@emotion/styled'
import React from 'react'
import { calcRem } from '../../__styling'

export const StyledInfiniteScrollContainer = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    marginTop: calcRem(16),
})
